




























import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'inversify-props';
import FEATURES from '@/modules/common/constants/features.constant';
import DateDocumentFilter from '@/modules/document-filters/components/date-document-filter.vue';
import UserService, { UserServiceS } from '@/modules/user/user.service';
import HotelsService, { HotelsServiceS } from '@/modules/hotels/hotels.service';
import MarketsHintTooltip from '@/modules/markets/components/markets-hint-tooltip.vue';

@Component({
    components: {
        DateDocumentFilter,
        MarketsHintTooltip,
    },
})
export default class MarketsHeader extends Vue {
    @Inject(UserServiceS) private userService!: UserService;
    @Inject(HotelsServiceS) private hotelsService!: HotelsService;

    infoTooltip: boolean = false;

    get isChainOrCluser() {
        return !this.$route.path.startsWith('/hotel');
    }

    get urlChainClusterParam() {
        if (this.userService.isClusterUser) {
            return 'cluster';
        }

        return 'chain';
    }

    get hotelName(): string | null {
        const { currentHotelId } = this.userService;
        if (!currentHotelId) {
            return null;
        }
        return this.hotelsService.getHotelName(currentHotelId);
    }

    get feature() {
        return FEATURES.MARKET;
    }

    get backRoute() {
        const branch = this.$route.name!.split('.')[0];

        switch (branch) {
            case 'chain':
                return {
                    name: 'chain.markets', // NOTE: Add .cluster after adding chain level
                    params: this.$route.params,
                };

            case 'cluster':
                return {
                    name: 'cluster.markets',
                };

            default: return {};
        }
    }
}
